import { render, staticRenderFns } from "./ChangeNotifySection.vue?vue&type=template&id=62589d18&scoped=true&"
import script from "./ChangeNotifySection.vue?vue&type=script&lang=js&"
export * from "./ChangeNotifySection.vue?vue&type=script&lang=js&"
import style0 from "./ChangeNotifySection.vue?vue&type=style&index=0&id=62589d18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62589d18",
  null
  
)

export default component.exports